import { LoadingSpinnerWrapper } from './styles';
import './styles.css';

type Props = typeof LoadingSpinnerWrapper.defaultProps;

export function LoadingSpinner({ ...props }: Props) {
  return (
    <LoadingSpinnerWrapper {...props}>
      <div />
    </LoadingSpinnerWrapper>
  );
}

interface RotatingRefreshIconProps {
  rotating: boolean;
}

export function RotatingRefreshIcon({ rotating }: RotatingRefreshIconProps) {
  return (
    <svg
      className={rotating ? 'rotate-refresh' : ''}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.516 1.00947 14.931 1.99122 16.74 3.74L19 6"
        stroke={rotating ? 'var(--colors-secondary)' : 'var(--colors-white)'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 1V6H14M19 10C19 12.3869 18.0518 14.6761 16.364 16.364C14.6761 18.0518 12.3869 19 10 19C7.48395 18.9905 5.06897 18.0088 3.26 16.26L1 14"
        stroke={rotating ? 'var(--colors-secondary)' : 'var(--colors-white)'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 14H1V19"
        stroke={rotating ? 'var(--colors-secondary)' : 'var(--colors-white)'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
